/**
 * ehr#484: a progress note's date is its session day, saved as that day at midnight UTC (the API
 * coerces "YYYY-MM-DD"). Read through `new Date()` in a US time zone it lands on the evening before
 * ("Fri, Oct 16, 5:00 PM" for a 10/17 note). This reads a midnight-UTC value as that calendar day at
 * local midnight, so the usual formatters and date filters see the right day. Any other value (an
 * appointment's real start time) is read as the instant it is.
 */
export function noteDate(v: string | Date): Date {
  const s = typeof v === 'string' ? v : Number.isNaN(v.getTime()) ? '' : v.toISOString();
  const m = /^(\d{4})-(\d{2})-(\d{2})(?:T00:00:00(?:\.000)?Z)?$/.exec(s);
  return m ? new Date(+m[1]!, +m[2]! - 1, +m[3]!) : new Date(v);
}
